import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import combineStyles from '../../utils/combineStyles';
import LayoutStyles from '../../styles/layout';
import SpacingStyles from '../../styles/helpers/spacing';
import TypographyStyles from '../../styles/typography';
import ButtonStyles from '../../styles/button';

import ShipmentBasicInfo from './BasicInfo';

export class BasicInfoSection extends Component {
  static propTypes = {
    shipment: PropTypes.shape({
      shipmentModeId: PropTypes.string.isRequired,
      pickup: PropTypes.object,
      delivery: PropTypes.object,
      shipmentDirectionId: PropTypes.string,
      bolNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      proNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      glCodeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  };

  render() {
    const { classes, t, shipment } = this.props;
    const EMPTY_STRING = '--';
    return (
      <Fragment>
        <div className={classes.titleRootWrapper}>
          <h2 className={classes.headline7}>{t('Basic Information')}</h2>
        </div>
        <Grid container spacing={16}>
          <Grid item lg={6}>
            <ShipmentBasicInfo
              type={t('Shipment Type')}
              details={[shipment.shipmentModeId]}
            />
          </Grid>
          <Grid item lg={6}>
            <ShipmentBasicInfo
              type={t('Shipment Direction')}
              details={[shipment.shipmentDirectionId]}
            />
          </Grid>
          <Grid item lg={6}>
            <ShipmentBasicInfo
              type={t('BOL Number')}
              details={shipment.bolNumber ? [`${shipment.bolNumber}`] : ['--']}
            />
          </Grid>
          <Grid item lg={6}>
            <ShipmentBasicInfo
              type={t('GL Code')}
              details={[shipment.glCodeId || EMPTY_STRING]}
            />
          </Grid>
          <Grid item lg={6}>
            <ShipmentBasicInfo
              type={t('Pro Number')}
              details={
                shipment.proNumber ? [`${shipment.proNumber}`] : [EMPTY_STRING]
              }
            />
          </Grid>
          <Grid item lg={6}>
            <ShipmentBasicInfo
              type={t('Carrier Pickup ID')}
              details={[shipment.carrierPickupNumber || EMPTY_STRING]}
            />
          </Grid>
        </Grid>

        {/*   
        <ShipmentBasicInfo
          type={t('Pickup Date')}
          details={[
            `${t('Planned')}: ${DateTime.formatDate(
              shipment.pickup.plannedToTimeLocal,
              { uppercase: true }
            )}`,
            `${t('Projected')}: ${DateTime.formatDate(
              shipment.pickup.projectedToTimeLocal,
              { uppercase: true }
            )}`,
            `${t('Actual')}: ${DateTime.formatDate(
              shipment.pickup.actualTimeLocal,
              { uppercase: true }
            )}`
          ]}
        /> */}
        {/*     <ShipmentBasicInfo
          type={t('Delivery Date')}
          details={[
            `${t('Planned')}: ${DateTime.formatDate(
              shipment.delivery.plannedToTimeLocal,
              { uppercase: true }
            )}`,
            `${t('Projected')}: ${DateTime.formatDate(
              shipment.delivery.projectedToTimeLocal,
              { uppercase: true }
            )}`,
            `${t('Actual')}: ${DateTime.formatDate(
              shipment.delivery.actualTimeLocal,
              { uppercase: true }
            )}`
          ]}
        />
        <ShipmentBasicInfo
          type={t('Shipment Direction')}
          details={[shipment.shipmentDirectionId]}
        />
        <ShipmentBasicInfo
          type={t('BOL Number')}
          details={[`#${shipment.bolNumber}` || t('None')]}
        />
        <ShipmentBasicInfo
          type={t('Pro Number')}
          details={[`#${shipment.proNumber}` || t('None')]}
        /> */}
      </Fragment>
    );
  }
}

const BasicInfoSectionWithTranslations = withNamespaces()(BasicInfoSection);
export default withStyles(
  combineStyles(TypographyStyles, LayoutStyles, SpacingStyles, ButtonStyles)
)(BasicInfoSectionWithTranslations);
